module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "micSetting flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "setting flexcenter"
  }, [_c('div', {
    staticClass: "settingInner"
  }, [_c('h3', {
    staticClass: "lbold font22"
  }, [_vm._v("設定")]), _vm._v(" "), _c('div', {
    staticClass: "settingContent"
  }, [_c('div', {
    staticClass: "settingContentInner"
  }, [_c('div', {
    staticClass: "flexstart config-mic"
  }, [_c('div', {
    staticClass: "settingtitle"
  }, [_vm._v("音声認識")]), _vm._v(" "), _c('div', {
    staticClass: "config"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [_c('div', {
    staticClass: "flexrow"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sreUse),
      expression: "sreUse"
    }],
    attrs: {
      "type": "radio",
      "id": "sreUseTrue",
      "value": "true",
      "disabled": _vm.locked
    },
    domProps: {
      "checked": _vm._q(_vm.sreUse, "true")
    },
    on: {
      "change": function($event) {
        _vm.sreUse = "true"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "sreUseTrue"
    }
  }, [_vm._v("有効")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sreUse),
      expression: "sreUse"
    }],
    attrs: {
      "type": "radio",
      "id": "sreUseFlase",
      "value": "false",
      "disabled": _vm.locked
    },
    domProps: {
      "checked": _vm._q(_vm.sreUse, "false")
    },
    on: {
      "change": function($event) {
        _vm.sreUse = "false"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "sreUseFlase"
    }
  }, [_vm._v("無効")])])]), _vm._v(" "), (_vm.isDocomo) ? _c('span', {
    staticClass: "configtitle font10"
  }, [_vm._v("有線のイヤホンマイク/ヘッドセットのご使用をされない場合、周囲の音や音声を拾って設問が進行することがあります。")]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.sreUse === 'false' || _vm.locked
    },
    on: {
      "click": _vm.settingMicrophone
    }
  }, [_c('span', [_vm._v("マイク設定")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "flexstart config-quality"
  }, [_c('div', {
    staticClass: "settingtitle"
  }, [_vm._v("音質")]), _vm._v(" "), _c('div', {
    staticClass: "config flexstart"
  }, _vm._l((_vm.genders), function(gender, index) {
    return _c('div', {
      key: index
    }, [_c('button', {
      class: {
        male: gender.value == 'male',
        female: gender.value == 'female',
        child: gender.value == 'child',
        active: gender.selected && _vm.sreUse === 'true'
      },
      attrs: {
        "type": "button",
        "disabled": _vm.sreUse === 'false' || _vm.locked
      },
      on: {
        "click": function($event) {
          return _vm.selectGender(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(gender.label))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flexstart config-pronunce"
  }, [_c('div', {
    staticClass: "settingtitle"
  }, [_vm._v("発音設定")]), _vm._v(" "), _c('div', {
    staticClass: "config",
    class: _vm.sreUse
  }, [_c('div', {
    class: {
      configtitle: true,
      font10: _vm.isDocomo,
      font13: !_vm.isDocomo
    }
  }, [_vm._v("(会話のアクティビティで目標とするスコアを設定してください)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.difficulty),
      expression: "difficulty"
    }],
    attrs: {
      "id": "range-pronunce",
      "type": "range",
      "disabled": _vm.sreUse === 'false' || _vm.locked,
      "min": "0",
      "max": "10",
      "list": "number"
    },
    domProps: {
      "value": (_vm.difficulty)
    },
    on: {
      "__r": function($event) {
        _vm.difficulty = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pronunce-datalist"
    }
  }, [_c('div', {
    staticClass: "pronunce-scale"
  }, [_c('span', {
    staticClass: "level0"
  }), _vm._v(" "), _c('span', {
    staticClass: "level1"
  }), _vm._v(" "), _c('span', {
    staticClass: "level2"
  }), _vm._v(" "), _c('span', {
    staticClass: "level3"
  }), _vm._v(" "), _c('span', {
    staticClass: "level4"
  }), _vm._v(" "), _c('span', {
    staticClass: "level5"
  }), _vm._v(" "), _c('span', {
    staticClass: "level6"
  }), _vm._v(" "), _c('span', {
    staticClass: "level7"
  }), _vm._v(" "), _c('span', {
    staticClass: "level8"
  }), _vm._v(" "), _c('span', {
    staticClass: "level9"
  }), _vm._v(" "), _c('span', {
    staticClass: "level10"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pronunce-label"
  }, [_c('span', {
    staticClass: "level0"
  }, [_vm._v("易しい")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "level3"
  }, [_vm._v("普通")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span', {
    staticClass: "level10"
  }, [_vm._v("難しい")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "flexstart config-sound"
  }, [_c('div', {
    staticClass: "settingtitle"
  }, [_vm._v("解答時の音")]), _vm._v(" "), _c('div', {
    staticClass: "config flexrow"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answerSound),
      expression: "answerSound"
    }],
    attrs: {
      "type": "radio",
      "id": "answerSoundTrue",
      "value": "true",
      "disabled": _vm.locked
    },
    domProps: {
      "checked": _vm._q(_vm.answerSound, "true")
    },
    on: {
      "change": function($event) {
        _vm.answerSound = "true"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "answerSoundTrue"
    }
  }, [_vm._v("有効")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answerSound),
      expression: "answerSound"
    }],
    attrs: {
      "type": "radio",
      "id": "answerSoundFlase",
      "value": "false",
      "disabled": _vm.locked
    },
    domProps: {
      "checked": _vm._q(_vm.answerSound, "false")
    },
    on: {
      "change": function($event) {
        _vm.answerSound = "false"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "answerSoundFlase"
    }
  }, [_vm._v("無効")])])])]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "flexstart config-textSize"
  }, [_c('div', {
    staticClass: "settingtitle"
  }, [_vm._v("文字サイズ")]), _vm._v(" "), _c('div', {
    staticClass: "config flexrow"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTextSize),
      expression: "selectedTextSize"
    }],
    attrs: {
      "type": "radio",
      "id": "textSizeLarge",
      "name": "textSizeSetting",
      "disabled": _vm.locked
    },
    domProps: {
      "value": _vm.textSizeList[0],
      "checked": _vm._q(_vm.selectedTextSize, _vm.textSizeList[0])
    },
    on: {
      "change": function($event) {
        _vm.selectedTextSize = _vm.textSizeList[0]
      }
    }
  }), _c('label', {
    attrs: {
      "for": "textSizeLarge"
    }
  }, [_vm._v("大きい")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTextSize),
      expression: "selectedTextSize"
    }],
    attrs: {
      "type": "radio",
      "id": "textSizeMiddle",
      "name": "textSizeSetting",
      "disabled": _vm.locked
    },
    domProps: {
      "value": _vm.textSizeList[1],
      "checked": _vm._q(_vm.selectedTextSize, _vm.textSizeList[1])
    },
    on: {
      "change": function($event) {
        _vm.selectedTextSize = _vm.textSizeList[1]
      }
    }
  }), _c('label', {
    attrs: {
      "for": "textSizeMiddle"
    }
  }, [_vm._v("標準")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTextSize),
      expression: "selectedTextSize"
    }],
    attrs: {
      "type": "radio",
      "id": "textSizeSmall",
      "name": "textSizeSetting",
      "disabled": _vm.locked
    },
    domProps: {
      "value": _vm.textSizeList[2],
      "checked": _vm._q(_vm.selectedTextSize, _vm.textSizeList[2])
    },
    on: {
      "change": function($event) {
        _vm.selectedTextSize = _vm.textSizeList[2]
      }
    }
  }), _c('label', {
    attrs: {
      "for": "textSizeSmall"
    }
  }, [_vm._v("小さい")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buttons flexcenter"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.locked
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v("キャンセル")])]), _vm._v(" "), _c('button', {
    staticClass: "apply",
    attrs: {
      "type": "button",
      "disabled": _vm.locked
    },
    on: {
      "click": _vm.applySettings
    }
  }, [_c('span', [_vm._v("適用")])])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2abc6a98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2abc6a98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting.vue
// module id = 611
// module chunks = 1